// Tools public
//
// Functions, utilities, and constants used in the project.
const CLASS_NAME_SHOW$1 = "show";
const CLASS_NAME_SHOW$2 = "active";
const CLASS_NAME_SHOW$3 = "hidden";

// tools-website-start
const getSelector = (element, attribute) => {
	let selector = element.getAttribute(attribute);

	if (!selector || selector === "#") {
		let hrefAttr = element.getAttribute("href");

		if (!hrefAttr || (!hrefAttr.includes("#") && !hrefAttr.startsWith("."))) {
			return null;
		}

		if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) {
			hrefAttr = `#${hrefAttr.split("#")[1]}`;
		}

		selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
	}

	return selector;
};

const getSelectorFromElement = (element, attribute) => {
	const selector = getSelector(element, attribute);

	if (selector) {
		return document.querySelector(selector) ? selector : null;
	}

	return null;
};

const onToggle = (element, nameClass = CLASS_NAME_SHOW$1) => {
	if (element === null) return null;

	element.classList.toggle(`${nameClass}`);
};

const onShow = (element, nameClass = CLASS_NAME_SHOW$1) => {
	if (element === null) return null;

	if (element.classList.contains(nameClass)) {
		return null;
	}

	element.classList.add(`${nameClass}`);
};

const onHide = (element, nameClass = CLASS_NAME_SHOW$1) => {
	if (element === null) return null;

	if (!element.classList.contains(nameClass)) {
		return null;
	}

	element.classList.remove(`${nameClass}`);
};

const updatedAttributes = (element, attribute, value) => {
	if (element === null) return null;

	if (!element.hasAttribute(attribute)) return null;

	element.setAttribute(attribute, value);
};

const onAriaExpanded = (element) => {
	if (element.ariaExpanded === null) return null;

	if (element.ariaExpanded === "true") {
		return element.setAttribute("aria-expanded", false);
	}

	return element.setAttribute("aria-expanded", true);
};

const onAriaHidden = (element) => {
	if (element.ariaHidden === null) return null;

	if (element.ariaHidden === "false") {
		return element.setAttribute("aria-hidden", true);
	}

	return element.setAttribute("aria-hidden", false);
};

const onStylesELement = (element, styles = "") => {
	if (element === null) return null;

	element.setAttribute("style", styles);
};

const onGetStorage = (searchItem) => {
	if (sessionStorage.getItem(searchItem) === null)
		return console.warn("No exist element in Storage");

	return sessionStorage.getItem(searchItem);
};

const onSetStorage = (searchItem, contentItem) => {
	if (sessionStorage.getItem(searchItem) === null)
		return console.warn(
			"No exist element in Storage, it is not possible updated element"
		);

	return sessionStorage.setItem(searchItem, contentItem);
};

// tools-website-end

// onActiveTab

const onActiveTab = (tab, tabs) => {
	let targetTab, tabContainer, elementContainer;

	tabs.forEach((elementTab) => {
		targetTab = document.getElementById(
			elementTab.getAttribute("aria-controls")
		);

		tabContainer = tab.dataset.tbTabs;
		elementContainer = elementTab.dataset.tbTabs;

		if (elementContainer === tabContainer) {
			if (elementTab === tab) {
				// Current tab click
				elementTab.setAttribute("aria-selected", true);
				onShow(elementTab, "active");

				// Target tab
				targetTab.removeAttribute("hidden");
				onShow(targetTab, "show");
			} else {
				// Others tabs
				elementTab.setAttribute("aria-selected", false);
				onHide(elementTab, "active");

				// Target tab
				targetTab.setAttribute("hidden", true);
				onHide(targetTab, "show");
			}
		}
	});
};

// onViewAccordion
const ACCORDION_ATTRIBUTE$2 = "[data-tb-accordion]";
const ACCORDION_ATTRIBUTE$3 = "[data-tb-accordion='box']";
const ACCORDION_ATTRIBUTE$4 = "[data-tb-accordion='wrap']";

const ACCORDION_CLASS_NAME$1 = "open";
const ACCORDION_CLASS_NAME$2 = "show";

const onOpenAccordion = (element) => {
	let elementParent, elementToExpanded, elementOfContent, heightToContent;
	// parent with attribute indicated
	elementParent = element.closest(ACCORDION_ATTRIBUTE$2);
	if (elementParent === null) return null;

	// open element and expanded parent
	onToggle(element, ACCORDION_CLASS_NAME$1);

	// search element box and wrap
	elementToExpanded = elementParent.querySelector(ACCORDION_ATTRIBUTE$3);
	elementOfContent = elementParent.querySelector(ACCORDION_ATTRIBUTE$4);

	if (elementToExpanded === null || elementOfContent === null) return null;

	// open element wrap
	onShow(elementOfContent, ACCORDION_CLASS_NAME$1);

	heightToContent =
		elementOfContent !== null ? elementOfContent.clientHeight : 0;

	if (element.classList.contains(ACCORDION_CLASS_NAME$1)) {
		elementToExpanded.style.height = `${heightToContent}px`;
		onShow(elementToExpanded, ACCORDION_CLASS_NAME$2);
	} else {
		onHide(elementToExpanded, ACCORDION_CLASS_NAME$2);
		elementToExpanded.style.height = `0px`;

		setTimeout(() => {
			// hidden element wrap
			onHide(elementOfContent, ACCORDION_CLASS_NAME$1);
		}, 1000);
	}
};

// onEffectButtons
let relY, relX, parentOffset;

const onEffectButtons = (elements, wrapeffect) => {
	elements.forEach((element) => {
		element.addEventListener("mouseenter", function (e) {
			parentOffset = $(this).offset();
			relX = e.pageX - parentOffset.left;
			relY = e.pageY - parentOffset.top;

			$(this).find(wrapeffect).css({ top: relY, left: relX });
		});

		element.addEventListener("mouseout", function (e) {
			parentOffset = $(this).offset();
			relX = e.pageX - parentOffset.left;
			relY = e.pageY - parentOffset.top;

			$(this).find(wrapeffect).css({ top: relY, left: relX });
		});
	});
};

// onChangesTabIndex

const onChangesTabIndex = (tagElement, getTabIndex, setTabIndex) => {
	let elements = document.querySelectorAll(
		`${tagElement}[tabindex="${getTabIndex}"]`
	);
	elements.forEach((element) => {
		element.setAttribute("tabindex", setTabIndex);
	});
};
